import React from "react";
import { Filters } from "./components/Filters";
import { StatusFilterBar } from "./components/StatusFilterBar";
import { QuestionsList } from "./components/QuestionsList";
import { useFilterState } from "./components/useFilterState";
import { Container, MainPanel, SidePanel } from "./components/styled";
import { Space } from "shared/ui";

const Questions = () => {
  const filters = useFilterState();

  return (
    <Container>
      <SidePanel>
        <Filters filters={filters} />
      </SidePanel>
      <Space size={32} />
      <MainPanel>
        <StatusFilterBar filters={filters} />
        <QuestionsList filters={filters} />
      </MainPanel>
    </Container>
  );
};

export default Questions;
